import React, { SVGProps } from "react";

export default function SupIconInput(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15 4H16V3H13V4H14V16H13V17H16V16H15V4Z" fill="currentColor" />
      <path d="M13 5H2V15H13V14H3V6H13V5Z" fill="currentColor" />
      <path d="M16 5V6H17V14H16V15H18V5H16Z" fill="currentColor" />
      <path d="M5.84 7.56L4.136 8.792L4.664 9.528L5.6 8.88V13H6.68V7.56H5.84Z" fill="currentColor" />
      <path
        d="M9.9983 11.2484C10.0772 11.2019 10.1583 11.1542 10.2402 11.104C10.3597 11.0317 10.4777 10.9633 10.5928 10.8965C11.3954 10.4309 12.0562 10.0475 12.0562 9.04C12.0562 8.192 11.4163 7.424 10.1523 7.424C9.18425 7.424 8.52825 7.904 7.97625 8.712L8.76825 9.272C9.26425 8.648 9.65625 8.344 10.1763 8.344C10.6403 8.344 10.9843 8.616 10.9843 9.056C10.9843 9.58995 10.5443 9.84145 9.96421 10.173C9.84031 10.2439 9.71001 10.3183 9.57625 10.4C9.55819 10.4111 9.5401 10.4221 9.52201 10.4332C8.75436 10.9025 7.96025 11.388 7.96025 12.576V13H12.0323V12.104H9.08825C9.1899 11.7245 9.56131 11.5058 9.9983 11.2484Z"
        fill="currentColor"
      />
    </svg>
  );
}
